import { useOnlineStatus } from "@/hooks/use-online-status";
import { WifiOff, Wifi, Check } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const OfflineIndicator = () => {
  const { isOnline, wasOffline } = useOnlineStatus();

  const showBanner = !isOnline || wasOffline;

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="overflow-hidden"
        >
          <div
            className={`flex items-center justify-center gap-2 py-1.5 px-4 text-xs font-semibold transition-colors duration-300 ${
              isOnline
                ? "bg-success/15 text-success"
                : "bg-primary/10 text-primary"
            }`}
          >
            {isOnline ? (
              <>
                <Check className="w-3.5 h-3.5" />
                Back online
              </>
            ) : (
              <>
                <WifiOff className="w-3.5 h-3.5" />
                Offline — all tools still work
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineIndicator;
